import Response from '../response';

class ResponseError extends Response {
  public readonly error;
  public readonly data;

  // @ts-ignore
  constructor(error) {
    super(null);

    this.error = error;

    this.data = null;

    this.isFailure = true;
    this.isSuccess = false;
  }
}

export default ResponseError;
